import { render, staticRenderFns } from "./NetaAttractionDetailsView.vue?vue&type=template&id=5094e445&scoped=true&"
import script from "./NetaAttractionDetailsView.vue?vue&type=script&lang=js&"
export * from "./NetaAttractionDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./NetaAttractionDetailsView.vue?vue&type=style&index=0&id=5094e445&lang=scss&scoped=true&"
import style1 from "./NetaAttractionDetailsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5094e445",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5094e445')) {
      api.createRecord('5094e445', component.options)
    } else {
      api.reload('5094e445', component.options)
    }
    module.hot.accept("./NetaAttractionDetailsView.vue?vue&type=template&id=5094e445&scoped=true&", function () {
      api.rerender('5094e445', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app-views/NetaAttractionDetailsView.vue"
export default component.exports